import { Container } from "./styles";

import profile from "../../assets/main-img.jpg"
import ScrollAnimation from "react-animate-on-scroll"

import react_icon from "../../assets/react-icon.svg"
import node from "../../assets/node-icon.svg"
import js from "../../assets/js-icon.svg"
import vue from "../../assets/vue-icon.svg"
import aws from "../../assets/aws-icon.svg"
import devops from "../../assets/devops-icon.svg"
import go from "../../assets/go-icon.svg"


export function About(){
  return(
    <Container id="sobre">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <h2>Details</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>I'm Ritik Chopra a Full-Stack Web Developer with intuitive problem-solving skills</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000} style={{marginTop: "2rem", marginBottom: "2rem"}}>

          <p>I have experience with various computer languages and multiple frameworks and libraries. 
            I'm expertise in Front-end, Back-end, and DevOps tools. 
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>

          <p>I'm always looking forward to learning new technology and tools which can help me reduce the overall work complexity.</p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>My Loved Ones 😍</h3>
        </ScrollAnimation>
        <div className="hard-skills">

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={js} alt="React" />
            </ScrollAnimation>
          </div>

          <div className="hability">
          <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
            <img src={node} alt="Vue" />
          </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img id="spinit" src={react_icon} alt="React" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={vue} alt="React" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={devops} alt="React" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={go} alt="React" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={aws} alt="React" />
            </ScrollAnimation>
          </div>

        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.1 * 1000}>
          <img src={profile} alt="PROFILE" height="750"/>
        </ScrollAnimation>
      </div>
    </Container>
  )
}
